import Header from '../components/Header'
import Footer from '../components/Footer'

type LegalSection = {
  title: string
  paragraphs: string[]
  list?: string[]
}

const sections: LegalSection[] = [
  {
    title: '1. 目的と適用範囲',
    paragraphs: [
      '本サイトポリシーは、一般社団法人 日本ITビジネス・プロフェッショナル協会（以下「当協会」といいます）が運営するウェブサイトをご利用いただく際の基本的な考え方を示すものです。',
      '本サイトをご利用された場合、本ポリシーに同意いただいたものとみなします。利用条件は予告なく変更されることがあるため、最新内容をご確認ください。',
    ],
  },
  {
    title: '2. 著作権・商標',
    paragraphs: [
      '本サイトに掲載される文章、画像、ロゴ、デザイン、プログラム等（以下「コンテンツ」といいます）の著作権・商標権は、当協会または正当な権利者に帰属します。',
      'コンテンツを無断で複製・改変・配布・転載することを禁止します。引用等を行う場合は、出典を明示し、学術的・報道的な正当性および適法性を担保してください。',
    ],
  },
  {
    title: '3. 禁止事項',
    paragraphs: ['利用者は、以下の行為を行ってはなりません。'],
    list: [
      '法律・条例・公序良俗に反する行為、またはその恐れがある行為',
      '当協会、会員、第三者の権利・利益・名誉を侵害する行為',
      '本サイトの運営を妨げる行為（サーバーへの過度なアクセス、改ざん、マルウェア送信等）',
      '虚偽の情報を登録・送信する行為、なりすまし行為',
      '営利目的での無断使用や勧誘行為（当協会が認めた場合を除く）',
    ],
  },
  {
    title: '4. リンクについて',
    paragraphs: [
      '本サイトへのリンクは、営利・非営利を問わず原則自由ですが、以下の条件を満たす場合に限ります。',
    ],
    list: [
      'リンク元サイトの運営主体が明確であり、社会通念上適切であること',
      '当協会や関係者を誹謗中傷したり信用を損なう内容を含まないこと',
      'フレーム内表示などにより当協会のコンテンツであることが不明瞭にならないこと',
      '当協会がリンク削除を要請した場合、速やかに応じること',
    ],
  },
  {
    title: '5. 免責事項',
    paragraphs: [
      '当協会は、本サイトの内容や提供する情報について正確性・最新性の確保に努めますが、その完全性を保証するものではありません。',
      '本サイトの利用、または利用できなかったことにより生じたいかなる損害についても、当協会は責任を負いません。',
      '予告なくコンテンツの追加・変更・削除、サイト全体の停止を行うことがあります。',
    ],
  },
  {
    title: '6. 個人情報・Cookieの取扱い',
    paragraphs: [
      'お問い合わせや会員登録等で取得した個人情報の取扱いについては「プライバシーポリシー」に従います。ともにご確認ください。',
      '本サイトでは、利便性向上と統計分析、セキュリティ強化を目的にCookie等の技術を利用する場合があります。ブラウザの設定でCookieを無効化できますが、一部機能が利用できなくなることがあります。',
    ],
  },
  {
    title: '7. セキュリティと信頼性確保',
    paragraphs: [
      '当協会は、公益性の高い団体として、通信の暗号化、アクセス制御、多層防御など適切なセキュリティ対策を講じます。',
      '万一不正アクセスや情報漏えい等が確認された場合は、速やかに事態を公表し、被害拡大の防止と再発防止策の実施に努めます。',
    ],
  },
  {
    title: '8. アクセシビリティとインクルージョン',
    paragraphs: [
      'IT活用機会の公平な提供という使命に基づき、読み上げ対応や対比比率の確保など、可能な範囲でアクセシビリティ向上の改善を継続します。',
      '利用者から寄せられた改善要望は、優先度評価のうえ、サイト改善やサービス設計に反映します。',
    ],
  },
  {
    title: '9. 準拠法および裁判管轄',
    paragraphs: [
      '本サイトの利用および本ポリシーの解釈・適用には、日本法が適用されます。',
      '本サイトに関して利用者と当協会の間で紛争が生じた場合、東京地方裁判所を第一審の専属的合意管轄裁判所とします。',
    ],
  },
]

const SitePolicyPage = () => {
  const breadcrumbs = [
    { label: 'ホーム', to: '/' },
    { label: 'サイトポリシー' },
  ]

  return (
    <>
      <Header breadcrumbs={breadcrumbs} />
      <main>
        <section className="page-hero" aria-labelledby="site-policy-title">
          <div className="container">
            <p className="section-pretitle">SITE POLICY</p>
            <h1 id="site-policy-title" className="page-hero-title">
              サイトポリシー
            </h1>
            <p className="page-hero-lead">
              当協会ウェブサイトをご利用いただく皆さまに安心して情報にアクセスいただくためのルールとお願いを定めています。
              公益性と透明性を重視した運営のもと、健全なITビジネス・エコシステムを共に築くため、ご確認ください。
            </p>
          </div>
        </section>

        <section className="legal-page" style={{ paddingTop: 0 }}>
          <div className="container">
            <div className="legal-sections">
              {sections.map((section) => (
                <article key={section.title} className="legal-section">
                  <h2>{section.title}</h2>
                  {section.paragraphs.map((paragraph) => (
                    <p key={paragraph}>{paragraph}</p>
                  ))}
                  {section.list && (
                    <ul>
                      {section.list.map((item) => (
                        <li key={item}>{item}</li>
                      ))}
                    </ul>
                  )}
                </article>
              ))}
            </div>
            <div className="legal-updated" aria-label="策定日">
              <span>制定日: 2026年4月1日</span>
              <span>最終改定日: 2026年4月1日</span>
            </div>
          </div>
        </section>
      </main>
      <Footer />
    </>
  )
}

export default SitePolicyPage


